// Countdown to the next required Schwab browser login (owner request 2026-10-04).
// The Schwab refresh token dies 7 days after the last FULL browser login; routine token refreshes do not move this
// deadline (shared/schwab_auth_manager.py get_status: last_full_auth_at + 7 days; TODO T-043). When it reaches zero the
// live data feed stops, so this sits at the top of the main dashboard page.
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { formatCountdown, tokenTone } from '../lib/schwabToken'

export default function SchwabLoginCountdown({ deadline, tokenStored = true, checked = true }) {
  const [now, setNow] = useState(Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [])

  const mono = { fontFamily: 'JetBrains Mono, monospace' }
  const box = { background: 'var(--bg-surface, rgba(255,255,255,0.03))', border: '1px solid rgba(255,255,255,0.08)' }

  if (!checked) {   // first status call not back yet: never flash "not authorized" (the 2026-09-29 header false alarm)
    return (
      <div className="rounded-lg px-4 py-3" style={box}>
        <span className="text-slate-500 uppercase tracking-wider" style={{ ...mono, fontSize: '0.68rem' }}>Schwab login · checking…</span>
      </div>
    )
  }

  if (!deadline || !tokenStored) {
    return (
      <div className="rounded-lg px-4 py-3 flex items-center justify-between flex-wrap gap-2" style={box}>
        <span className="text-slate-500 uppercase tracking-wider" style={{ ...mono, fontSize: '0.68rem' }}>Schwab login</span>
        <span className="text-slate-400" style={{ ...mono, fontSize: '0.8rem' }}>Not authorized — no live data without a login</span>
        <Link to="/settings" className="text-sky-400 hover:text-sky-300" style={{ ...mono, fontSize: '0.72rem' }}>Open Settings</Link>
      </div>
    )
  }

  const ms = new Date(deadline).getTime() - now
  const tone = tokenTone(ms)
  const when = new Date(deadline).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' })
  return (
    <div className="rounded-lg px-4 py-3 flex items-center justify-between flex-wrap gap-3"
      style={{ ...box, borderColor: tone.level === 'ok' ? 'rgba(255,255,255,0.08)' : tone.color }}
      title="The Schwab refresh token expires 7 days after the last full browser login. Routine refreshes do not extend it; only a new login does.">
      <div>
        <p className="text-slate-500 uppercase tracking-wider" style={{ ...mono, fontSize: '0.68rem' }}>
          Next Schwab login due <span style={{ opacity: 0.6 }}>· without it the live data feed stops</span>
        </p>
        <div className="flex items-baseline gap-3 mt-1 flex-wrap">
          <span className="text-2xl font-semibold" style={{ ...mono, color: tone.color }}>{formatCountdown(ms)}</span>
          <span className="text-slate-500" style={{ fontSize: '0.8rem' }}>until {when}</span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <span style={{ ...mono, fontSize: '0.72rem', color: tone.color, letterSpacing: '0.08em' }}>{tone.label}</span>
        {tone.level !== 'ok' && (
          <Link to="/settings" className="rounded-lg px-3 py-1.5 border text-slate-200 hover:bg-gray-800"
            style={{ ...mono, fontSize: '0.72rem', borderColor: tone.color }}>Log in to Schwab</Link>
        )}
      </div>
    </div>
  )
}
